import { render, staticRenderFns } from "./UploadLegenda.vue?vue&type=template&id=149927fd"
import script from "./UploadLegenda.vue?vue&type=script&lang=js"
export * from "./UploadLegenda.vue?vue&type=script&lang=js"
import style0 from "./UploadLegenda.vue?vue&type=style&index=0&id=149927fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports